import React, { useEffect } from 'react';

const ProgressBar = () => {
    useEffect(() => {
        const progressWrap = document.querySelector(".progress-wrap");
        if (!progressWrap) return;

        const progressPath = progressWrap.querySelector("path");
        const pathLength = progressPath.getTotalLength();

        progressPath.style.transition = "none";
        progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
        progressPath.style.strokeDashoffset = pathLength;

        progressPath.getBoundingClientRect(); 
        progressPath.style.transition = "stroke-dashoffset 10ms linear";

        const updateProgress = () => {
            const scroll = window.scrollY;
            const height = document.documentElement.scrollHeight - window.innerHeight;
            const progress = pathLength - (scroll * pathLength) / height;
            progressPath.style.strokeDashoffset = progress;
        };

        updateProgress();
        window.addEventListener("scroll", updateProgress);

        
        const handleScroll = () => {
            if (window.scrollY > 200) {
                progressWrap.classList.add("active-progress");
            } else {
                progressWrap.classList.remove("active-progress");
            }
        };

        window.addEventListener("scroll", handleScroll);

        progressWrap.addEventListener("click", (event) => {
            event.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
        });

        return () => {
            window.removeEventListener("scroll", updateProgress);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div className="progress-wrap">
            <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
                    style={{
                        transition: "stroke-dashoffset 10ms linear",
                        strokeDasharray: "307.919, 307.919",
                        strokeDashoffset: "307.919",
                        strokeWidth: "2px"
                  
                    }}>
                </path>
            </svg>
        </div>
    );
};

export default ProgressBar;
